var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assignedTools && _vm.assignedTools.length > 0)?_c('div',{staticClass:"assigned-tools-list"},[_c('base-grid',{attrs:{"items":_vm.assignedTools,"imageUrls":_vm.imageUrls},on:{"grid:badge:click":function($event){return _vm.$router.push({
          path: $event.url
        })}}})],1):_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" You do not have any tools assigned. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }